import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";
import { isNativeApp } from "../lib/native";
import { Button } from "./ui/button";
import { tr } from "../lib/i18n";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

// "Add to Home Screen" nudge: native prompt on Android/Chrome, manual instructions on iOS Safari.
export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const native = isNativeApp();

  useEffect(() => {
    if (isStandalone()) return;
    try { if (localStorage.getItem("hv_install_dismissed")) return; } catch { /* no storage */ }
    const onBIP = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onBIP);
    if (isIOS()) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onBIP);
  }, []);

  const dismiss = () => { setShow(false); try { localStorage.setItem("hv_install_dismissed", "1"); } catch { /* no storage */ } };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch { /* dismissed */ }
    setDeferred(null); dismiss();
  };

  if (native) return null;
  if (!show) return null;
  const ios = isIOS();
  return (
    <div data-testid="install-prompt" className="mt-4 rounded-2xl border border-primary/30 bg-primary/5 px-4 py-3 flex flex-wrap items-center gap-3 text-sm">
      <span className="h-8 w-8 rounded-xl bg-primary/10 text-primary grid place-items-center shrink-0"><Download className="h-4 w-4" /></span>
      <div className="flex-1 min-w-[220px]">
        <b>{tr("Install HearthVault on your phone")}</b>{" "}
        <span className="text-muted-foreground">
          {ios
            ? <>{tr("Tap")} <Share className="inline h-3.5 w-3.5 -mt-0.5 text-primary" /> {tr("Share, then “Add to Home Screen” for one-tap, full-screen access.")}</>
            : tr("Add it to your home screen for one-tap, full-screen access — it works just like an app.")}
        </span>
      </div>
      {!ios && <Button size="sm" data-testid="install-prompt-btn" onClick={install} className="h-8 rounded-full gap-1.5"><Download className="h-3.5 w-3.5" /> {tr("Install")}</Button>}
      <button data-testid="install-prompt-dismiss" onClick={dismiss} className="p-1 rounded-full text-muted-foreground hover:text-foreground" title={tr("Not now")}><X className="h-4 w-4" /></button>
    </div>
  );
};
